import React from "react";
import { Chip, ThemeProvider, createTheme } from "@mui/material";
import colors from "../themes/colors";
import { dt } from "../themes/redesignTokens";

type PresetChipProps = {
  label?: string;
  active?: boolean;
  onClick?: () => void;
};

const PresetChip = ({ label, active, onClick }: PresetChipProps) => {
  const handleClick = () => {
    onClick && onClick();
  };

  const theme = createTheme({
    components: {
      MuiChip: {
        styleOverrides: {
          root: {
            padding: "4px 8px",
            color: dt.blue,
            background: active ? colors.primary.lightBlue3 : colors.primary.white1,
            border: `2px solid ${colors.primary.lightBlue3}`,
            "&:hover": {
              background: colors.primary.lightBlue3
            }
          },
          label: {
            fontSize: 12,
            fontWeight: 600,
            padding: 0
          }
        }
      }
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <Chip label={label} onClick={handleClick} />
    </ThemeProvider>
  );
};

export default PresetChip;